import { useEffect, useState } from "react";
import { subscriptionApi } from "../../services/userApi";
import { useSubscription } from "../../context/SubscriptionContext";
import { useToast } from "../../context/ToastContext";
import { Card } from "../../components/common/Card";
import { Button } from "../../components/common/Button";
import { Badge } from "../../components/common/Badge";
import { Spinner } from "../../components/common/Spinner";
import styles from "./SubscriptionSettingsTab.module.css";

export function SubscriptionSettingsTab() {
  const { status, refresh } = useSubscription();
  const { notify } = useToast();
  const [plans, setPlans] = useState(null);
  const [busy, setBusy] = useState(null);

  useEffect(() => {
    subscriptionApi.plans().then((r) => setPlans(r.plans));
  }, []);

  if (!plans || !status) return <Spinner />;

  async function changeTier(tier) {
    setBusy(tier);
    try {
      await subscriptionApi.update(tier);
      await refresh();
      notify(`Subscription changed to ${tier}`, "success");
    } catch (err) {
      notify(err.apiMessage || "Could not change plan", "danger");
    } finally {
      setBusy(null);
    }
  }

  return (
    <div>
      <Card title="Current Usage" className="section-spacing">
        <p>{status.active_hive_count} active hive{status.active_hive_count === 1 ? "" : "s"} {status.hive_limit ? `of ${status.hive_limit}` : "(unlimited)"}</p>
      </Card>

      <div className={styles.grid}>
        {plans.map((plan) => (
          <Card key={plan.tier} className={[styles.card, status.tier === plan.tier ? styles.selected : ""].join(" ")}>
            <div className={styles.header}>
              <h3>{plan.tier}</h3>
              {status.tier === plan.tier && <Badge tone="honey">Current</Badge>}
            </div>
            <div className={styles.price}>{plan.price_monthly_usd === 0 ? "Free" : `$${plan.price_monthly_usd}/mo`}</div>
            <ul className={styles.features}>
              {plan.features.map((f) => <li key={f}>{f}</li>)}
            </ul>
            <Button disabled={status.tier === plan.tier || busy === plan.tier} onClick={() => changeTier(plan.tier)}>
              {busy === plan.tier ? "Switching…" : status.tier === plan.tier ? "Current Plan" : "Select"}
            </Button>
          </Card>
        ))}
      </div>
    </div>
  );
}
